import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, {
  getDefaultAutorizedHeaders,
  toFormData,
} from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  API_URL_APPLICATION_ITEM,
  API_URL_APPLICATION_TABLE,
  API_URL_APPLICATION_LIST,
} from 'constants/index'
import NoticeHelper from 'helpers/notice'
import {
  APPLICATION_FETCH_TABLE_DATA,
  APPLICATION_FETCH_TABLE_DATA_SUCCESS,
  APPLICATION_FETCH_TABLE_DATA_FAILURE,
  APPLICATION_DELETE,
  APPLICATION_FETCH_FORM_DATA,
  APPLICATION_FETCH_FORM_DATA_SUCCESS,
  APPLICATION_FETCH_FORM_DATA_FAILURE,
  APPLICATION_CHANGE,
  APPLICATION_UPLOAD_ICON,
  APPLICATION_UPLOAD_ICON_SUCCESS,
  APPLICATION_UPLOAD_ICON_FAILURE,
  APPLICATION_UPLOAD_SMALL_ICON,
  APPLICATION_UPLOAD_SMALL_ICON_SUCCESS,
  APPLICATION_UPLOAD_SMALL_ICON_FAILURE,
} from './reducer'
import { SHOW_NOTICE } from '../notice'
import * as ApiRouter from '../../constants/apiRouting'
import { FETCH_PROFILE } from '../profile/reducer'

function* applicationFetchTableData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_APPLICATION_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response || !response.error) {
      yield put({
        type: APPLICATION_FETCH_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: APPLICATION_FETCH_TABLE_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('APPLICATION INTERFACE ERROR', error)
  }
}

function* applicationFetchFormData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_APPLICATION_ITEM, {
        id: action.payload.entityId,
      }),
    })
    if (!response || !response.error) {
      yield put({
        type: APPLICATION_FETCH_FORM_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: APPLICATION_FETCH_FORM_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('SISENSE ERROR', error)
  }
}

function* applicationChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: !entityId ? 'POST' : 'PUT',
      partUrl: !entityId
        ? API_URL_APPLICATION_LIST
        : UrlHelper.create(API_URL_APPLICATION_ITEM, { id: entityId }),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Application ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`APPLICATION INTERFACE ERROR: ${error}`)
  }
}

function* applicationDelete(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(API_URL_APPLICATION_ITEM, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Application delete successful'),
      })

      return yield applicationFetchTableData(action)
    }

    console.log('APPLICATION DELETE UNKNOWN ERROR. RESPONSE: ', response)
  } catch (error) {
    console.log('APPLICATION INTERFACE ERROR', error)
  }
}

function* applicationUploadIcon(action) {
  const { fileData, entityId, message } = action.payload
  try {
    const value = yield call(fetchFromAPI, {
      data: toFormData({ icon: fileData }),
      headers: getDefaultAutorizedHeaders({
        'Content-Type': 'multipart/form-data',
        'X-HTTP-Method-Override': 'PUT',
      }),
      method: 'POST',
      partUrl: UrlHelper.createQuery(
        UrlHelper.create(ApiRouter.APPLICATION_UPLOAD_ICON, {
          id: entityId,
        }),
      ),
    })

    if (!value || !value.error) {
      yield put({ type: APPLICATION_UPLOAD_ICON_SUCCESS, payload: value })
      yield put({ type: FETCH_PROFILE })
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(message),
      })
    } else {
      yield put({ type: APPLICATION_UPLOAD_ICON_FAILURE })
    }
  } catch (error) {
    console.error(error.toString())
  }
}

function* applicationUploadSmallIcon(action) {
  const { fileData, entityId, message } = action.payload
  try {
    const value = yield call(fetchFromAPI, {
      data: toFormData({ smallIcon: fileData }),
      headers: getDefaultAutorizedHeaders({
        'Content-Type': 'multipart/form-data',
        'X-HTTP-Method-Override': 'PUT',
      }),
      method: 'POST',
      partUrl: UrlHelper.createQuery(
        UrlHelper.create(ApiRouter.APPLICATION_UPLOAD_SMALL_ICON, {
          id: entityId,
        }),
      ),
    })

    if (!value || !value.error) {
      yield put({ type: APPLICATION_UPLOAD_SMALL_ICON_SUCCESS, payload: value })
      yield put({ type: FETCH_PROFILE })
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(message),
      })
    } else {
      yield put({ type: APPLICATION_UPLOAD_SMALL_ICON_FAILURE })
    }
  } catch (error) {
    console.error(error.toString())
  }
}

function* applicationSaga() {
  yield takeLatest(APPLICATION_FETCH_TABLE_DATA, applicationFetchTableData)
  yield takeLatest(APPLICATION_DELETE, applicationDelete)
  yield takeLatest(APPLICATION_FETCH_FORM_DATA, applicationFetchFormData)
  yield takeLatest(APPLICATION_CHANGE, applicationChange)
  yield takeLatest(APPLICATION_UPLOAD_ICON, applicationUploadIcon)
  yield takeLatest(APPLICATION_UPLOAD_SMALL_ICON, applicationUploadSmallIcon)
}

export default applicationSaga
